import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm, Controller } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { Editor } from "components/shared/Editor";
import { addBlog, getBlogCategories } from "store/actions";
import { useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import { getId } from "helpers/functions";
import ImageUploadEn from "./ImageUploadEn";

const AddBlog = () => {
  const [selectedMainImage, setSelectedMainImage] = useState();
  const [description, setDescription] = useState({ ar: "", en: "" });
  const [tags, setTags] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { locale } = useIntl();

  const { blogCategories } = useSelector((state) => state.blogCategories);
  const { blogTags } = useSelector((state) => state.blogs) || {};

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    dispatch(getBlogCategories());
  }, [dispatch]);

  const renderCategoriesOptions = blogCategories?.map((category) => (
    <option value={getId(category)}>{category?.title?.[locale]}</option>
  ));

  const onSubmit = async (data) => {
    try {
      if (selectedMainImage) data.image = selectedMainImage.path;
      // data.images = additionalImages.length
      //   ? additionalImages?.filter((imageObj) => !!imageObj?.file?.path)
      //     .map((imageObj) => imageObj?.file?.path) : [];
      data.description = description;
      data.tags = tags;
      await dispatch(addBlog({ data, navigate }));
    } catch (error) {
      console.error("Error submitting blog:", error);
    }
  };

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id="addBlog" />
            </h4>
          </div>
          <div className="card-body form-group settings-tabs">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  {/* Main Image Upload */}
                  <Col lg={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="image" />
                      </h5>
                      <ImageUploadEn
                        selectedImageEn={selectedMainImage}
                        setSelectedImageEn={setSelectedMainImage}
                        accept="image/*"
                      />
                    </div>
                  </Col>

                  {/* Category Select */}
                  {/* <Col xs={12}>
                    <div className="form-group required">
                      <h5>
                        {" "}
                        <FormattedMessage id="category" />
                      </h5>
                      <div>
                        <select
                          style={{ backgroundPosition: "left 0.70rem center" }}
                          className="form-control form-select"
                          {...register("category", { required: true })}
                        >
                          <option value="">اختر التصنيف</option>
                          {renderCategoriesOptions}
                        </select>
                      </div>
                      <p className="error-hint">
                        {errors.category?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col> */}

                  {/* Title Inputs */}
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="title" />{" "}
                        <FormattedMessage id="arabic-language" />
                      </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("title.ar", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.title?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="title" />{" "}
                        <FormattedMessage id="english-language" />
                      </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("title.en", { required: true })}
                      />
                      <p className="error-hint">
                        {errors.title?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>

                  {/* Description Editors */}
                  <Col lg={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="description" />{" "}
                        <FormattedMessage id="arabic-language" />
                      </h5>
                      <Controller
                        control={control}
                        name="description.ar"
                        render={() => (
                          <Editor
                            initialValue=""
                            onChange={(e, editor) => {
                              const data = editor.getContent();
                              setDescription((prev) => ({
                                ...prev,
                                ar: data,
                              }));
                            }}
                          />
                        )}
                      />
                      <p className="error-hint">
                        {errors.description?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="description" />{" "}
                        <FormattedMessage id="english-language" />
                      </h5>
                      <Controller
                        control={control}
                        name="description.en"
                        render={() => (
                          <Editor
                            initialValue=""
                            onChange={(e, editor) => {
                              const data = editor.getContent();
                              setDescription((prev) => ({
                                ...prev,
                                en: data,
                              }));
                            }}
                          />
                        )}
                      />
                      <p className="error-hint">
                        {errors.description?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>

                  {/* Keywords */}
                  <Col lg={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id="tags" />
                      </h5>
                      <Controller
                        control={control}
                        name="tags"
                        render={({ field: { onChange, value, selected } }) => (
                          <CreatableSelect
                            isMulti
                            className="basic-single creatable-select"
                            classNamePrefix="select"
                            placeholder="Add Keywords"
                            onChange={(selected) => {
                              const newTags = selected.map((tag) => tag.label);
                              setTags(newTags);
                            }}
                            options={blogTags.map((tag) => ({
                              value: tag,
                              label: tag,
                            }))}
                          />
                        )}
                      />
                      <p className="error-hint">
                        {errors.tags?.type === "required" &&
                          "Please enter some keywords"}
                      </p>
                    </div>
                  </Col>
                </Row>
              </Col>

              {/* Submit Button */}
              <Col lg={4}>
                <div className="form-group mt-3">
                  <button type="submit" className="btn btn-blue">
                    <FormattedMessage id="add" />
                  </button>
                </div>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBlog;
